const initialState = {
  banner: null, //支付页面顶部banner
  subscriptionTypes: [], //套餐列表
  subscription_type_ids: null, //默认选中的套餐列表
  defaultSubscriptionTypeId: null, //默认的套餐ID
  newCombo: {
    currentPrice: '', //当前选中的套餐的应付金额
    currentPromoCode: null, //当前选中的套餐的优惠券
    currentSubscriotionType: null, //当前选中的套餐
    isSelectedAutoRenew: true //当前套餐是否选中开通免密
  },

  cancelQuestionarie: null, //取消支付的问卷数据
  leaveQuestionarie: null, //离开支付页面的问卷数据
  inPlans: false
}

function reducer(state = initialState, action) {
  switch (action.type) {
    // 获取套餐信息成功
    case 'GET:EXTENDABLE:SUBSCRIPTION:TYPES:SUCCESS':
      return updateSubscriptionTypes(state, action)

    // 获取当前套餐的 Preview 成功
    case 'API:FETCH:PREIVEW:SUBSCRIPTION:TYPE:SUCCESS': {
      const { subscription_type, me } = action.response.data

      return {
        ...state,
        me: me,
        newCombo: {
          ...state.newCombo,
          currentPrice: subscription_type.preview.final_price,
          currentSubscriotionType: subscription_type
        }
      }
    }

    // 获取支付页面顶部banner成功
    case 'API:COPY:WRITING:ADJUSTMENTS:SUCCESS': {
      return updatePlansBanner(state, action)
    }

    // 更新选中的套餐
    case 'SET:CURRENT_SUBSCRIPTION_TYPE':
      return updateCurrentSubscriptionType(state, action)

    // 更新套餐选择的优惠券
    case 'SET:SUBSCRIPTION_TYPE_PROMO_CODE':
      return updateCurrentSubscriptionTypePromoCode(state, action)

    // 更新当前套餐的自动续费开关
    case 'SET:PLANS_AUTO_RENEW_STATUS':
      return updateCurrentPlanAutoRenewStatus(state, action)

    // 更新 subscription_type_ids
    case 'SET:SUBSCRIPTION_TYPE_IDS':
      return { ...state, subscription_type_ids: action.ids }
    // 重置 subscription_type_ids
    case 'RESET:SUBSCRIPTION_TYPE_IDS':
      return {
        ...state,
        newCombo: state.inPlans
          ? { ...state.newCombo }
          : {
              currentPrice: '',
              currentPromoCode: null, //当前选中的套餐的优惠券
              currentSubscriotionType: null,
              isSelectedAutoRenew: true
            },
        subscription_type_ids: null
      }

    //从plans页面跳转，标记状态，保留数据返回到plans不重置
    case 'SET:INPLANS':
      return { ...state, inPlans: action.inPlans }

    case 'API:QUESTIONARIE:LEAVE:SUCCESS':
      return { ...state, leaveQuestionarie: action.response }

    case 'API:PLANS:QUESTIONARIE:SUCCESS':
      return { ...state, cancelQuestionarie: action.response }

    case 'SET:RESET_CURRENT_SUBSCRIPTION_TYPE':
      return resetCurrentSubscriptionType(state)

    default:
      return state
  }
}

function updateSubscriptionTypes(state, action) {
  const { extendable_subscription_types_v3 } = action.response.data
  const {
    subscription_groups,
    default_select_subscription_type_id
  } = extendable_subscription_types_v3

  return {
    ...state,
    newCombo: { ...state.newCombo },
    subscriptionGroups: subscription_groups,
    defaultSubscriptionTypeId: default_select_subscription_type_id
  }
}

//切换选中的套餐
function updateCurrentSubscriptionType(state, action) {
  return {
    ...state,
    newCombo: {
      currentPrice: '',
      currentPromoCode: null,
      currentSubscriotionType: action.subscriptionType,
      isSelectedAutoRenew: true
    }
  }
}

const updateCurrentSubscriptionTypePromoCode = (state, action) => {
  return {
    ...state,
    newCombo: { ...state.newCombo, currentPromoCode: action.promoCode }
  }
}

const updatePlansBanner = (state, action) => {
  const { copywriting_adjustments } = action.response.data

  return {
    ...state,
    banner: copywriting_adjustments.subscriber_benefit_image_url
  }
}

const updateCurrentPlanAutoRenewStatus = (state, action) => {
  return {
    ...state,
    newCombo: { ...state.newCombo, isSelectedAutoRenew: action.status }
  }
}

const resetCurrentSubscriptionType = state => {
  return {
    ...state,
    subscription_type_ids: null, //默认选中的套餐列表
    newCombo: {
      currentPrice: '', //当前选中的套餐的应付金额
      currentPromoCode: null, //当前选中的套餐的优惠券
      currentSubscriotionType: null, //当前选中的套餐
      isSelectedAutoRenew: true //当前套餐是否选中开通免密
    },
    inPlans: false
  }
}

export default reducer
